/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    AdminNewsPost,
    ApiErrorResponse,
    BakeryAddresses,
    CategoryRequest,
    CreateAccountRequest,
    CreateOrderRequest,
    CreateOrderResponse,
    FinishAddPasskeyRequest,
    FinishLoginRequest,
    FinishRegistrationRequest,
    FullOrder,
    InviteResponse,
    ItemRequest,
    LegalLinks,
    ListAccountsResponse,
    ListAdminItemsResponse,
    ListAdminNewsPostsResponse,
    ListCategoriesResponse,
    ListItemsResponse,
    ListOrdersResponse,
    ListPasskeysResponse,
    ListPickupDaysResponse,
    ListPublishedNewsPostsResponse,
    MeResponse,
    NewsPostRequest,
    OrderStatus,
    PickupDayChangeResponse,
    PickupWindowResponse,
    ProcurementSummary,
    PublicOrder,
    ScheduleSchema,
    SetItemImageRequest,
    StartAddPasskeyResponse,
    StartLoginRequest,
    StartLoginResponse,
    StartRegistrationRequest,
    StartRegistrationResponse,
    StatisticsPositionsResponse,
    UpdateAccountRequest,
    UpdateOrderItemPackedRequest,
    UpdateOrderStatusRequest,
    UpdatePickupDayRequest,
} from '../models/index';

export interface CancelOrderRequest {
    /**
     * 
     */
    pickup_code: string;
}

export interface CreateAccountOperationRequest {
    /**
     * 
     */
    CreateAccountRequest?: CreateAccountRequest;
}

export interface CreateCategoryRequest {
    /**
     * 
     */
    CategoryRequest?: CategoryRequest;
}

export interface CreateInviteRequest {
    /**
     * 
     */
    uuid: string;
}

export interface CreateItemRequest {
    /**
     * 
     */
    ItemRequest?: ItemRequest;
}

export interface CreateNewsPostRequest {
    /**
     * 
     */
    NewsPostRequest?: NewsPostRequest;
}

export interface CreateOrderOperationRequest {
    /**
     * 
     */
    CreateOrderRequest?: CreateOrderRequest;
}

export interface DeleteAccountRequest {
    /**
     * 
     */
    uuid: string;
}

export interface DeleteCategoryRequest {
    /**
     * 
     */
    uuid: string;
}

export interface DeleteItemRequest {
    /**
     * 
     */
    uuid: string;
}

export interface DeleteItemImageRequest {
    /**
     * 
     */
    uuid: string;
}

export interface DeleteNewsPostRequest {
    /**
     * 
     */
    uuid: string;
}

export interface DeletePasskeyRequest {
    /**
     * 
     */
    uuid: string;
}

export interface FinishAddPasskeyOperationRequest {
    /**
     * 
     */
    FinishAddPasskeyRequest?: FinishAddPasskeyRequest;
}

export interface FinishLoginOperationRequest {
    /**
     * 
     */
    FinishLoginRequest?: FinishLoginRequest;
}

export interface FinishRegistrationOperationRequest {
    /**
     * 
     */
    FinishRegistrationRequest?: FinishRegistrationRequest;
}

export interface GetNewsPostRequest {
    /**
     * 
     */
    uuid: string;
}

export interface GetOrderRequest {
    /**
     * 
     */
    pickup_code: string;
}

export interface GetOrderDetailRequest {
    /**
     * 
     */
    uuid: string;
}

export interface GetProcurementSummaryRequest {
    /**
     * 
     */
    date: string;
}

export interface GetStatisticsPositionsRequest {
    /**
     * 
     */
    from?: string;
    /**
     * 
     */
    to?: string;
}

export interface ListOrdersRequest {
    /**
     * 
     */
    pickup_date?: string | null;
    /**
     * 
     */
    status?: OrderStatus | null;
}

export interface LockPickupDayRequest {
    /**
     * 
     */
    rule_date: string;
}

export interface PublishNewsPostRequest {
    /**
     * 
     */
    uuid: string;
}

export interface SetItemImageOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    SetItemImageRequest?: SetItemImageRequest;
}

export interface StartLoginOperationRequest {
    /**
     * 
     */
    StartLoginRequest?: StartLoginRequest;
}

export interface StartRegistrationOperationRequest {
    /**
     * 
     */
    StartRegistrationRequest?: StartRegistrationRequest;
}

export interface UpdateAccountOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    UpdateAccountRequest?: UpdateAccountRequest;
}

export interface UpdateBakeryAddressesRequest {
    /**
     * 
     */
    BakeryAddresses?: BakeryAddresses;
}

export interface UpdateCategoryRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    CategoryRequest?: CategoryRequest;
}

export interface UpdateItemRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    ItemRequest?: ItemRequest;
}

export interface UpdateLegalSettingsRequest {
    /**
     * 
     */
    LegalLinks?: LegalLinks;
}

export interface UpdateNewsPostRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    NewsPostRequest?: NewsPostRequest;
}

export interface UpdateOrderItemPackedOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    UpdateOrderItemPackedRequest?: UpdateOrderItemPackedRequest;
}

export interface UpdateOrderStatusOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    UpdateOrderStatusRequest?: UpdateOrderStatusRequest;
}

export interface UpdatePickupDayOperationRequest {
    /**
     * 
     */
    rule_date: string;
    /**
     * 
     */
    UpdatePickupDayRequest?: UpdatePickupDayRequest;
}

export interface UpdateScheduleRequest {
    /**
     * 
     */
    ScheduleSchema?: ScheduleSchema;
}

export interface WithdrawNewsPostRequest {
    /**
     * 
     */
    uuid: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for cancelOrder without sending the request
     */
    async cancelOrderRequestOpts(requestParameters: CancelOrderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pickup_code'] == null) {
            throw new runtime.RequiredError(
                'pickup_code',
                'Required parameter "pickup_code" was null or undefined when calling cancelOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/orders/{pickup_code}/cancel`;
        urlPath = urlPath.replace('{pickup_code}', encodeURIComponent(String(requestParameters['pickup_code'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Cancel an order by its pickup code  Only until the pickup day\'s deadline: afterwards the bakery has the order and the customer has to call. The pickup code is a weak bearer secret, so every cancellation is logged — a guessed code cancelling someone else\'s order should be visible after the fact.
     * Cancel an order by its pickup code
     */
    async cancelOrderRaw(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicOrder>> {
        const requestOptions = await this.cancelOrderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel an order by its pickup code  Only until the pickup day\'s deadline: afterwards the bakery has the order and the customer has to call. The pickup code is a weak bearer secret, so every cancellation is logged — a guessed code cancelling someone else\'s order should be visible after the fact.
     * Cancel an order by its pickup code
     */
    async cancelOrder(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicOrder> {
        const response = await this.cancelOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createAccount without sending the request
     */
    async createAccountRequestOpts(requestParameters: CreateAccountOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateAccountRequest'],
        };
    }

    /**
     * Create a staff account and return its one-time registration link
     * Create a staff account and return its one-time registration link
     */
    async createAccountRaw(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InviteResponse>> {
        const requestOptions = await this.createAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a staff account and return its one-time registration link
     * Create a staff account and return its one-time registration link
     */
    async createAccount(requestParameters: CreateAccountOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InviteResponse> {
        const response = await this.createAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCategory without sending the request
     */
    async createCategoryRequestOpts(requestParameters: CreateCategoryRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/categories`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CategoryRequest'],
        };
    }

    /**
     * Create a category
     * Create a category
     */
    async createCategoryRaw(requestParameters: CreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.createCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create a category
     * Create a category
     */
    async createCategory(requestParameters: CreateCategoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createInvite without sending the request
     */
    async createInviteRequestOpts(requestParameters: CreateInviteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling createInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}/invite`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Issue a new one-time registration link for an account (\"lost device\")
     * Issue a new one-time registration link for an account (\"lost device\")
     */
    async createInviteRaw(requestParameters: CreateInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InviteResponse>> {
        const requestOptions = await this.createInviteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Issue a new one-time registration link for an account (\"lost device\")
     * Issue a new one-time registration link for an account (\"lost device\")
     */
    async createInvite(requestParameters: CreateInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InviteResponse> {
        const response = await this.createInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createItem without sending the request
     */
    async createItemRequestOpts(requestParameters: CreateItemRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/items`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ItemRequest'],
        };
    }

    /**
     * Create an item
     * Create an item
     */
    async createItemRaw(requestParameters: CreateItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.createItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create an item
     * Create an item
     */
    async createItem(requestParameters: CreateItemRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createNewsPost without sending the request
     */
    async createNewsPostRequestOpts(requestParameters: CreateNewsPostRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/news-posts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['NewsPostRequest'],
        };
    }

    /**
     * Create a News Post as a Draft
     * Create a News Post as a Draft
     */
    async createNewsPostRaw(requestParameters: CreateNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.createNewsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create a News Post as a Draft
     * Create a News Post as a Draft
     */
    async createNewsPost(requestParameters: CreateNewsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createNewsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrder without sending the request
     */
    async createOrderRequestOpts(requestParameters: CreateOrderOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/shop/orders`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateOrderRequest'],
        };
    }

    /**
     * Place a pre-order  Customers need no account: name plus phone or email is enough. The pickup date is not chosen by the customer — it is whichever day is currently open, and the order closes with that day\'s deadline.
     * Place a pre-order
     */
    async createOrderRaw(requestParameters: CreateOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrderResponse>> {
        const requestOptions = await this.createOrderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Place a pre-order  Customers need no account: name plus phone or email is enough. The pickup date is not chosen by the customer — it is whichever day is currently open, and the order closes with that day\'s deadline.
     * Place a pre-order
     */
    async createOrder(requestParameters: CreateOrderOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrderResponse> {
        const response = await this.createOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAccount without sending the request
     */
    async deleteAccountRequestOpts(requestParameters: DeleteAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a staff account  Admins cannot delete themselves.
     * Delete a staff account
     */
    async deleteAccountRaw(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a staff account  Admins cannot delete themselves.
     * Delete a staff account
     */
    async deleteAccount(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteCategory without sending the request
     */
    async deleteCategoryRequestOpts(requestParameters: DeleteCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/categories/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a category  Items of the category are kept (their category is set to null).
     * Delete a category
     */
    async deleteCategoryRaw(requestParameters: DeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a category  Items of the category are kept (their category is set to null).
     * Delete a category
     */
    async deleteCategory(requestParameters: DeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCategoryRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteItem without sending the request
     */
    async deleteItemRequestOpts(requestParameters: DeleteItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/items/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete an item  Positions of existing orders keep their snapshots (item link set to null). Prefer deactivating items over deleting them.
     * Delete an item
     */
    async deleteItemRaw(requestParameters: DeleteItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an item  Positions of existing orders keep their snapshots (item link set to null). Prefer deactivating items over deleting them.
     * Delete an item
     */
    async deleteItem(requestParameters: DeleteItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteItemRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteItemImage without sending the request
     */
    async deleteItemImageRequestOpts(requestParameters: DeleteItemImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteItemImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/items/{uuid}/image`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove an item\'s product photo
     * Remove an item\'s product photo
     */
    async deleteItemImageRaw(requestParameters: DeleteItemImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteItemImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove an item\'s product photo
     * Remove an item\'s product photo
     */
    async deleteItemImage(requestParameters: DeleteItemImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteItemImageRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteNewsPost without sending the request
     */
    async deleteNewsPostRequestOpts(requestParameters: DeleteNewsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteNewsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/news-posts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a News Post for good
     * Delete a News Post for good
     */
    async deleteNewsPostRaw(requestParameters: DeleteNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteNewsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a News Post for good
     * Delete a News Post for good
     */
    async deleteNewsPost(requestParameters: DeleteNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNewsPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deletePasskey without sending the request
     */
    async deletePasskeyRequestOpts(requestParameters: DeletePasskeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deletePasskey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/passkeys/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete one of the logged-in account\'s passkeys  The last passkey cannot be deleted — the account would be locked out.
     * Delete one of the logged-in account\'s passkeys
     */
    async deletePasskeyRaw(requestParameters: DeletePasskeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePasskeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete one of the logged-in account\'s passkeys  The last passkey cannot be deleted — the account would be locked out.
     * Delete one of the logged-in account\'s passkeys
     */
    async deletePasskey(requestParameters: DeletePasskeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePasskeyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for finishAddPasskey without sending the request
     */
    async finishAddPasskeyRequestOpts(requestParameters: FinishAddPasskeyOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/passkeys/finish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FinishAddPasskeyRequest'],
        };
    }

    /**
     * Finish adding another passkey to the logged-in account
     * Finish adding another passkey to the logged-in account
     */
    async finishAddPasskeyRaw(requestParameters: FinishAddPasskeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.finishAddPasskeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish adding another passkey to the logged-in account
     * Finish adding another passkey to the logged-in account
     */
    async finishAddPasskey(requestParameters: FinishAddPasskeyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finishAddPasskeyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for finishLogin without sending the request
     */
    async finishLoginRequestOpts(requestParameters: FinishLoginOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/login/finish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FinishLoginRequest'],
        };
    }

    /**
     * Finish a passkey login  Verifies the browser\'s credential and logs the account in.
     * Finish a passkey login
     */
    async finishLoginRaw(requestParameters: FinishLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeResponse>> {
        const requestOptions = await this.finishLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Finish a passkey login  Verifies the browser\'s credential and logs the account in.
     * Finish a passkey login
     */
    async finishLogin(requestParameters: FinishLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeResponse> {
        const response = await this.finishLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finishRegistration without sending the request
     */
    async finishRegistrationRequestOpts(requestParameters: FinishRegistrationOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/register/finish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FinishRegistrationRequest'],
        };
    }

    /**
     * Finish an invite-based passkey registration
     * Finish an invite-based passkey registration
     */
    async finishRegistrationRaw(requestParameters: FinishRegistrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.finishRegistrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish an invite-based passkey registration
     * Finish an invite-based passkey registration
     */
    async finishRegistration(requestParameters: FinishRegistrationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finishRegistrationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getBakeryAddresses without sending the request
     */
    async getBakeryAddressesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/bakery`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get where the Bakery order goes at the Dispatch
     * Get where the Bakery order goes at the Dispatch
     */
    async getBakeryAddressesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BakeryAddresses>> {
        const requestOptions = await this.getBakeryAddressesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get where the Bakery order goes at the Dispatch
     * Get where the Bakery order goes at the Dispatch
     */
    async getBakeryAddresses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BakeryAddresses> {
        const response = await this.getBakeryAddressesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCategories without sending the request
     */
    async getCategoriesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/categories`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all categories
     * List all categories
     */
    async getCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCategoriesResponse>> {
        const requestOptions = await this.getCategoriesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all categories
     * List all categories
     */
    async getCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCategoriesResponse> {
        const response = await this.getCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getItems without sending the request
     */
    async getItemsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/items`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all currently orderable items
     * List all currently orderable items
     */
    async getItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListItemsResponse>> {
        const requestOptions = await this.getItemsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all currently orderable items
     * List all currently orderable items
     */
    async getItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListItemsResponse> {
        const response = await this.getItemsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLegalLinks without sending the request
     */
    async getLegalLinksRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/legal`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The shop\'s imprint and privacy policy links  Public and unauthenticated: the footer showing them is on every page, including the ones nobody is logged in for — which is the whole point of an imprint.
     * The shop\'s imprint and privacy policy links
     */
    async getLegalLinksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegalLinks>> {
        const requestOptions = await this.getLegalLinksRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The shop\'s imprint and privacy policy links  Public and unauthenticated: the footer showing them is on every page, including the ones nobody is logged in for — which is the whole point of an imprint.
     * The shop\'s imprint and privacy policy links
     */
    async getLegalLinks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegalLinks> {
        const response = await this.getLegalLinksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLegalSettings without sending the request
     */
    async getLegalSettingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/legal`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the imprint and privacy policy links
     * Get the imprint and privacy policy links
     */
    async getLegalSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegalLinks>> {
        const requestOptions = await this.getLegalSettingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the imprint and privacy policy links
     * Get the imprint and privacy policy links
     */
    async getLegalSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegalLinks> {
        const response = await this.getLegalSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getNewsPost without sending the request
     */
    async getNewsPostRequestOpts(requestParameters: GetNewsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getNewsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/news-posts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get one News Post, Draft or Published
     * Get one News Post, Draft or Published
     */
    async getNewsPostRaw(requestParameters: GetNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminNewsPost>> {
        const requestOptions = await this.getNewsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get one News Post, Draft or Published
     * Get one News Post, Draft or Published
     */
    async getNewsPost(requestParameters: GetNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminNewsPost> {
        const response = await this.getNewsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrder without sending the request
     */
    async getOrderRequestOpts(requestParameters: GetOrderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pickup_code'] == null) {
            throw new runtime.RequiredError(
                'pickup_code',
                'Required parameter "pickup_code" was null or undefined when calling getOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/orders/{pickup_code}`;
        urlPath = urlPath.replace('{pickup_code}', encodeURIComponent(String(requestParameters['pickup_code'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get an order by its pickup code  Deliberately does not echo phone/email: the code is a weak bearer secret, so a guessed code must not leak contact data.
     * Get an order by its pickup code
     */
    async getOrderRaw(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicOrder>> {
        const requestOptions = await this.getOrderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get an order by its pickup code  Deliberately does not echo phone/email: the code is a weak bearer secret, so a guessed code must not leak contact data.
     * Get an order by its pickup code
     */
    async getOrder(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicOrder> {
        const response = await this.getOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrderDetail without sending the request
     */
    async getOrderDetailRequestOpts(requestParameters: GetOrderDetailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getOrderDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/verkauf/orders/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a single order
     * Get a single order
     */
    async getOrderDetailRaw(requestParameters: GetOrderDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullOrder>> {
        const requestOptions = await this.getOrderDetailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get a single order
     * Get a single order
     */
    async getOrderDetail(requestParameters: GetOrderDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullOrder> {
        const response = await this.getOrderDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPickupWindow without sending the request
     */
    async getPickupWindowRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/pickup`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The pickup day customers can currently order for  The only place the frontend learns the date and the deadline from — computing either in the browser would drift from the server the moment the two disagree about the timezone.
     * The pickup day customers can currently order for
     */
    async getPickupWindowRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PickupWindowResponse>> {
        const requestOptions = await this.getPickupWindowRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The pickup day customers can currently order for  The only place the frontend learns the date and the deadline from — computing either in the browser would drift from the server the moment the two disagree about the timezone.
     * The pickup day customers can currently order for
     */
    async getPickupWindow(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PickupWindowResponse> {
        const response = await this.getPickupWindowRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProcurementSummary without sending the request
     */
    async getProcurementSummaryRequestOpts(requestParameters: GetProcurementSummaryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getProcurementSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/verkauf/pickup-days/{date}/summary`;
        urlPath = urlPath.replace('{date}', encodeURIComponent(String(requestParameters['date'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * What has to be procured for one pickup day  The bakery order: every position of every non-cancelled order of that day, summed per item. Final once the day is Dispatched.
     * What has to be procured for one pickup day
     */
    async getProcurementSummaryRaw(requestParameters: GetProcurementSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcurementSummary>> {
        const requestOptions = await this.getProcurementSummaryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * What has to be procured for one pickup day  The bakery order: every position of every non-cancelled order of that day, summed per item. Final once the day is Dispatched.
     * What has to be procured for one pickup day
     */
    async getProcurementSummary(requestParameters: GetProcurementSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcurementSummary> {
        const response = await this.getProcurementSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSchedule without sending the request
     */
    async getScheduleRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/schedule`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the recurring rule pickup days are generated from
     * Get the recurring rule pickup days are generated from
     */
    async getScheduleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduleSchema>> {
        const requestOptions = await this.getScheduleRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the recurring rule pickup days are generated from
     * Get the recurring rule pickup days are generated from
     */
    async getSchedule(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduleSchema> {
        const response = await this.getScheduleRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStatisticsPositions without sending the request
     */
    async getStatisticsPositionsRequestOpts(requestParameters: GetStatisticsPositionsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/statistics/positions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The positions of every order placed or picked up in a period  A position is returned when its order was placed on one of the period\'s days (Europe/Berlin) or its pickup day\'s effective date lies in it.
     * The positions of every order placed or picked up in a period
     */
    async getStatisticsPositionsRaw(requestParameters: GetStatisticsPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsPositionsResponse>> {
        const requestOptions = await this.getStatisticsPositionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The positions of every order placed or picked up in a period  A position is returned when its order was placed on one of the period\'s days (Europe/Berlin) or its pickup day\'s effective date lies in it.
     * The positions of every order placed or picked up in a period
     */
    async getStatisticsPositions(requestParameters: GetStatisticsPositionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsPositionsResponse> {
        const response = await this.getStatisticsPositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAccounts without sending the request
     */
    async listAccountsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/accounts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all staff accounts
     * List all staff accounts
     */
    async listAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccountsResponse>> {
        const requestOptions = await this.listAccountsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all staff accounts
     * List all staff accounts
     */
    async listAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccountsResponse> {
        const response = await this.listAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCategories without sending the request
     */
    async listCategoriesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/categories`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all categories
     * List all categories
     */
    async listCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCategoriesResponse>> {
        const requestOptions = await this.listCategoriesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all categories
     * List all categories
     */
    async listCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCategoriesResponse> {
        const response = await this.listCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listItems without sending the request
     */
    async listItemsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/items`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all items, including inactive ones
     * List all items, including inactive ones
     */
    async listItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAdminItemsResponse>> {
        const requestOptions = await this.listItemsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all items, including inactive ones
     * List all items, including inactive ones
     */
    async listItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAdminItemsResponse> {
        const response = await this.listItemsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listNewsPosts without sending the request
     */
    async listNewsPostsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/news-posts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all News Posts, Drafts included, newest first
     * List all News Posts, Drafts included, newest first
     */
    async listNewsPostsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAdminNewsPostsResponse>> {
        const requestOptions = await this.listNewsPostsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all News Posts, Drafts included, newest first
     * List all News Posts, Drafts included, newest first
     */
    async listNewsPosts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAdminNewsPostsResponse> {
        const response = await this.listNewsPostsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listOrders without sending the request
     */
    async listOrdersRequestOpts(requestParameters: ListOrdersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pickup_date'] != null) {
            queryParameters['pickup_date'] = requestParameters['pickup_date'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/verkauf/orders`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List orders, optionally filtered by status and pickup date
     * List orders, optionally filtered by status and pickup date
     */
    async listOrdersRaw(requestParameters: ListOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOrdersResponse>> {
        const requestOptions = await this.listOrdersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List orders, optionally filtered by status and pickup date
     * List orders, optionally filtered by status and pickup date
     */
    async listOrders(requestParameters: ListOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOrdersResponse> {
        const response = await this.listOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPasskeys without sending the request
     */
    async listPasskeysRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/passkeys`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the passkeys of the logged-in account
     * List the passkeys of the logged-in account
     */
    async listPasskeysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPasskeysResponse>> {
        const requestOptions = await this.listPasskeysRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List the passkeys of the logged-in account
     * List the passkeys of the logged-in account
     */
    async listPasskeys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPasskeysResponse> {
        const response = await this.listPasskeysRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPickupDays without sending the request
     */
    async listPickupDaysRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/pickup-days`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the upcoming pickup days
     * List the upcoming pickup days
     */
    async listPickupDaysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPickupDaysResponse>> {
        const requestOptions = await this.listPickupDaysRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List the upcoming pickup days
     * List the upcoming pickup days
     */
    async listPickupDays(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPickupDaysResponse> {
        const response = await this.listPickupDaysRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPublishedNewsPosts without sending the request
     */
    async listPublishedNewsPostsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shop/news-posts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the Published News Posts, newest first
     * List the Published News Posts, newest first
     */
    async listPublishedNewsPostsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPublishedNewsPostsResponse>> {
        const requestOptions = await this.listPublishedNewsPostsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List the Published News Posts, newest first
     * List the Published News Posts, newest first
     */
    async listPublishedNewsPosts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPublishedNewsPostsResponse> {
        const response = await this.listPublishedNewsPostsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for lockPickupDay without sending the request
     */
    async lockPickupDayRequestOpts(requestParameters: LockPickupDayRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['rule_date'] == null) {
            throw new runtime.RequiredError(
                'rule_date',
                'Required parameter "rule_date" was null or undefined when calling lockPickupDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/pickup-days/{rule_date}/lock`;
        urlPath = urlPath.replace('{rule_date}', encodeURIComponent(String(requestParameters['rule_date'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Freeze a pickup day right now, before its deadline  Runs the same path the deadline job runs. The Dispatch stays where it is: the confirmations go out at the Deadline plus the Review Window.
     * Freeze a pickup day right now, before its deadline
     */
    async lockPickupDayRaw(requestParameters: LockPickupDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PickupDayChangeResponse>> {
        const requestOptions = await this.lockPickupDayRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Freeze a pickup day right now, before its deadline  Runs the same path the deadline job runs. The Dispatch stays where it is: the confirmations go out at the Deadline plus the Review Window.
     * Freeze a pickup day right now, before its deadline
     */
    async lockPickupDay(requestParameters: LockPickupDayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PickupDayChangeResponse> {
        const response = await this.lockPickupDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for logout without sending the request
     */
    async logoutRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Log out of the current session
     * Log out of the current session
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.logoutRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Log out of the current session
     * Log out of the current session
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutRaw(initOverrides);
    }

    /**
     * Creates request options for me without sending the request
     */
    async meRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the currently logged-in account
     * Get the currently logged-in account
     */
    async meRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeResponse>> {
        const requestOptions = await this.meRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the currently logged-in account
     * Get the currently logged-in account
     */
    async me(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeResponse> {
        const response = await this.meRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for publishNewsPost without sending the request
     */
    async publishNewsPostRequestOpts(requestParameters: PublishNewsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling publishNewsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/news-posts/{uuid}/publish`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Publish a News Post now  Publishing a withdrawn News Post again gives it a new publication time.
     * Publish a News Post now
     */
    async publishNewsPostRaw(requestParameters: PublishNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminNewsPost>> {
        const requestOptions = await this.publishNewsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Publish a News Post now  Publishing a withdrawn News Post again gives it a new publication time.
     * Publish a News Post now
     */
    async publishNewsPost(requestParameters: PublishNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminNewsPost> {
        const response = await this.publishNewsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setItemImage without sending the request
     */
    async setItemImageRequestOpts(requestParameters: SetItemImageOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling setItemImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/items/{uuid}/image`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetItemImageRequest'],
        };
    }

    /**
     * Set an item\'s product photo  Accepts jpeg/png/webp, downscales to a bounded size and stores a re-encoded jpeg.
     * Set an item\'s product photo
     */
    async setItemImageRaw(requestParameters: SetItemImageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setItemImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set an item\'s product photo  Accepts jpeg/png/webp, downscales to a bounded size and stores a re-encoded jpeg.
     * Set an item\'s product photo
     */
    async setItemImage(requestParameters: SetItemImageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setItemImageRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startAddPasskey without sending the request
     */
    async startAddPasskeyRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/passkeys/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Start adding another passkey to the logged-in account
     * Start adding another passkey to the logged-in account
     */
    async startAddPasskeyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartAddPasskeyResponse>> {
        const requestOptions = await this.startAddPasskeyRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start adding another passkey to the logged-in account
     * Start adding another passkey to the logged-in account
     */
    async startAddPasskey(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartAddPasskeyResponse> {
        const response = await this.startAddPasskeyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startLogin without sending the request
     */
    async startLoginRequestOpts(requestParameters: StartLoginOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/login/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['StartLoginRequest'],
        };
    }

    /**
     * Start a passkey login for a given username  The account\'s passkeys are sent as the credential allow-list, so this works with roaming authenticators (e.g. YubiKeys) whose credentials are not client-side discoverable.
     * Start a passkey login for a given username
     */
    async startLoginRaw(requestParameters: StartLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartLoginResponse>> {
        const requestOptions = await this.startLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start a passkey login for a given username  The account\'s passkeys are sent as the credential allow-list, so this works with roaming authenticators (e.g. YubiKeys) whose credentials are not client-side discoverable.
     * Start a passkey login for a given username
     */
    async startLogin(requestParameters: StartLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartLoginResponse> {
        const response = await this.startLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startRegistration without sending the request
     */
    async startRegistrationRequestOpts(requestParameters: StartRegistrationOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/register/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['StartRegistrationRequest'],
        };
    }

    /**
     * Start an invite-based passkey registration
     * Start an invite-based passkey registration
     */
    async startRegistrationRaw(requestParameters: StartRegistrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartRegistrationResponse>> {
        const requestOptions = await this.startRegistrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start an invite-based passkey registration
     * Start an invite-based passkey registration
     */
    async startRegistration(requestParameters: StartRegistrationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartRegistrationResponse> {
        const response = await this.startRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for test without sending the request
     */
    async testRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/test`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Cheap probe whether the session is logged in
     * Cheap probe whether the session is logged in
     */
    async testRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.testRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cheap probe whether the session is logged in
     * Cheap probe whether the session is logged in
     */
    async test(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testRaw(initOverrides);
    }

    /**
     * Creates request options for updateAccount without sending the request
     */
    async updateAccountRequestOpts(requestParameters: UpdateAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateAccountRequest'],
        };
    }

    /**
     * Update a staff account  Admins cannot demote themselves — this avoids locking the last admin out of account management.
     * Update a staff account
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a staff account  Admins cannot demote themselves — this avoids locking the last admin out of account management.
     * Update a staff account
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateBakeryAddresses without sending the request
     */
    async updateBakeryAddressesRequestOpts(requestParameters: UpdateBakeryAddressesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/bakery`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['BakeryAddresses'],
        };
    }

    /**
     * Change the Bakery and copy address  An empty value unsets the address. Without a Bakery address no pickup day is Dispatched; setting one Dispatches the waiting days on the next tick.
     * Change the Bakery and copy address
     */
    async updateBakeryAddressesRaw(requestParameters: UpdateBakeryAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BakeryAddresses>> {
        const requestOptions = await this.updateBakeryAddressesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change the Bakery and copy address  An empty value unsets the address. Without a Bakery address no pickup day is Dispatched; setting one Dispatches the waiting days on the next tick.
     * Change the Bakery and copy address
     */
    async updateBakeryAddresses(requestParameters: UpdateBakeryAddressesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BakeryAddresses> {
        const response = await this.updateBakeryAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCategory without sending the request
     */
    async updateCategoryRequestOpts(requestParameters: UpdateCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/categories/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CategoryRequest'],
        };
    }

    /**
     * Rename a category
     * Rename a category
     */
    async updateCategoryRaw(requestParameters: UpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rename a category
     * Rename a category
     */
    async updateCategory(requestParameters: UpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCategoryRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateItem without sending the request
     */
    async updateItemRequestOpts(requestParameters: UpdateItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/items/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ItemRequest'],
        };
    }

    /**
     * Update an item  Existing orders are unaffected: they carry name/price snapshots.
     * Update an item
     */
    async updateItemRaw(requestParameters: UpdateItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an item  Existing orders are unaffected: they carry name/price snapshots.
     * Update an item
     */
    async updateItem(requestParameters: UpdateItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateItemRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateLegalSettings without sending the request
     */
    async updateLegalSettingsRequestOpts(requestParameters: UpdateLegalSettingsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/legal`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['LegalLinks'],
        };
    }

    /**
     * Change the imprint and privacy policy links  An empty value removes the link from the footer.
     * Change the imprint and privacy policy links
     */
    async updateLegalSettingsRaw(requestParameters: UpdateLegalSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegalLinks>> {
        const requestOptions = await this.updateLegalSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change the imprint and privacy policy links  An empty value removes the link from the footer.
     * Change the imprint and privacy policy links
     */
    async updateLegalSettings(requestParameters: UpdateLegalSettingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegalLinks> {
        const response = await this.updateLegalSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateNewsPost without sending the request
     */
    async updateNewsPostRequestOpts(requestParameters: UpdateNewsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateNewsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/news-posts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['NewsPostRequest'],
        };
    }

    /**
     * Change a News Post\'s title and body  A Published News Post keeps its publication time.
     * Change a News Post\'s title and body
     */
    async updateNewsPostRaw(requestParameters: UpdateNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminNewsPost>> {
        const requestOptions = await this.updateNewsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change a News Post\'s title and body  A Published News Post keeps its publication time.
     * Change a News Post\'s title and body
     */
    async updateNewsPost(requestParameters: UpdateNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminNewsPost> {
        const response = await this.updateNewsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateOrderItemPacked without sending the request
     */
    async updateOrderItemPackedRequestOpts(requestParameters: UpdateOrderItemPackedOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateOrderItemPacked().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/verkauf/order-items/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateOrderItemPackedRequest'],
        };
    }

    /**
     * Change a position\'s packed flag (packing list checkbox)
     * Change a position\'s packed flag (packing list checkbox)
     */
    async updateOrderItemPackedRaw(requestParameters: UpdateOrderItemPackedOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateOrderItemPackedRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change a position\'s packed flag (packing list checkbox)
     * Change a position\'s packed flag (packing list checkbox)
     */
    async updateOrderItemPacked(requestParameters: UpdateOrderItemPackedOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrderItemPackedRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateOrderStatus without sending the request
     */
    async updateOrderStatusRequestOpts(requestParameters: UpdateOrderStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateOrderStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/verkauf/orders/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateOrderStatusRequest'],
        };
    }

    /**
     * Change an order\'s status  Allowed transitions: `Open -> Ready -> PickedUp`; `Open | Ready -> Cancelled`. A cancelled order\'s customer gets a mail, also after the Dispatch.
     * Change an order\'s status
     */
    async updateOrderStatusRaw(requestParameters: UpdateOrderStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullOrder>> {
        const requestOptions = await this.updateOrderStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change an order\'s status  Allowed transitions: `Open -> Ready -> PickedUp`; `Open | Ready -> Cancelled`. A cancelled order\'s customer gets a mail, also after the Dispatch.
     * Change an order\'s status
     */
    async updateOrderStatus(requestParameters: UpdateOrderStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullOrder> {
        const response = await this.updateOrderStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePickupDay without sending the request
     */
    async updatePickupDayRequestOpts(requestParameters: UpdatePickupDayOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['rule_date'] == null) {
            throw new runtime.RequiredError(
                'rule_date',
                'Required parameter "rule_date" was null or undefined when calling updatePickupDay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/pickup-days/{rule_date}`;
        urlPath = urlPath.replace('{rule_date}', encodeURIComponent(String(requestParameters['rule_date'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdatePickupDayRequest'],
        };
    }

    /**
     * Change a single pickup day  Identified by its rule date, which never changes — the pickup date does. Calling a day off cancels its orders and mails the customers.
     * Change a single pickup day
     */
    async updatePickupDayRaw(requestParameters: UpdatePickupDayOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PickupDayChangeResponse>> {
        const requestOptions = await this.updatePickupDayRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change a single pickup day  Identified by its rule date, which never changes — the pickup date does. Calling a day off cancels its orders and mails the customers.
     * Change a single pickup day
     */
    async updatePickupDay(requestParameters: UpdatePickupDayOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PickupDayChangeResponse> {
        const response = await this.updatePickupDayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSchedule without sending the request
     */
    async updateScheduleRequestOpts(requestParameters: UpdateScheduleRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/schedule`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ScheduleSchema'],
        };
    }

    /**
     * Change the recurring rule  Only affects days that have no override yet — a day somebody already touched keeps the date and deadline it was given.
     * Change the recurring rule
     */
    async updateScheduleRaw(requestParameters: UpdateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduleSchema>> {
        const requestOptions = await this.updateScheduleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change the recurring rule  Only affects days that have no override yet — a day somebody already touched keeps the date and deadline it was given.
     * Change the recurring rule
     */
    async updateSchedule(requestParameters: UpdateScheduleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduleSchema> {
        const response = await this.updateScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for withdrawNewsPost without sending the request
     */
    async withdrawNewsPostRequestOpts(requestParameters: WithdrawNewsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling withdrawNewsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/news-posts/{uuid}/withdraw`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Withdraw a News Post, making it a Draft again
     * Withdraw a News Post, making it a Draft again
     */
    async withdrawNewsPostRaw(requestParameters: WithdrawNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminNewsPost>> {
        const requestOptions = await this.withdrawNewsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Withdraw a News Post, making it a Draft again
     * Withdraw a News Post, making it a Draft again
     */
    async withdrawNewsPost(requestParameters: WithdrawNewsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminNewsPost> {
        const response = await this.withdrawNewsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
